import {
  GET_INCIDENTS_REQUEST,
  GET_INCIDENTS_SUCCESS,
  GET_INCIDENTS_FAIL,
  GET_INCIDENT_DETAILS_REQUEST,
  GET_INCIDENT_DETAILS_SUCCESS,
  GET_INCIDENT_DETAILS_FAIL,
  TOGGLE_NAV_HIDE,
  BACKEND_REDIRECTION_REQUEST,
  BACKEND_REDIRECTION_SUCCESS,
  BACKEND_REDIRECTION_FAIL,
  GET_FILTER_LOOKUP_REQUEST,
  GET_FILTER_LOOKUP_SUCCESS,
  GET_FILTER_LOOKUP_FAIL,
  GET_SUMMARY_REQUEST,
  GET_SUMMARY_SUCCESS,
  GET_SUMMARY_FAIL,
  GET_LAST_REFRESH_DATE_SUCCESS,
  GET_COVERAGE_STREET_DATA_SUCCESS,
  GET_VPI_TRENDS_SUCCESS,
  GET_STREET_COVERAGE_SUCCESS,
  GET_ROAD_OPTIONS_SUCCESS,
  GET_COVERAGE_PROGRESS_REQUEST,
  GET_COVERAGE_PROGRESS_SUCCESS,
  GET_COVERAGE_PROGRESS_FAIL,
  GET_MUNICIPALITY_AND_STREET_DATA_REQUEST,
  GET_MUNICIPALITY_AND_STREET_DATA_SUCCESS,
  GET_MUNICIPALITY_AND_STREET_DATA_FAIL,
  GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_REQUEST,
  GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_SUCCESS,
  GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_FAIL,
  GET_USERS_SUCCESS,
  GET_HIGHEST_ELEMENTS_DATA_REQUEST,
  GET_HIGHEST_ELEMENTS_DATA_SUCCESS,
  GET_HIGHEST_ELEMENTS_DATA_FAIL,
  GET_VPI_DATA_REQUEST,
  GET_VPI_DATA_SUCCESS,
  GET_VPI_TRENDS_FAIL,
  GET_SMART_SUPERVISION_SUMMARY_REQUEST,
  GET_SMART_SUPERVISION_SUMMARY_SUCCESS,
  GET_SMART_SUPERVISION_SUMMARY_FAIL,
  GET_DETECTION_QUALITY_FILTER_LOOKUP_REQUEST,
  GET_DETECTION_QUALITY_FILTER_LOOKUP_SUCCESS,
  GET_DETECTION_QUALITY_FILTER_LOOKUP_FAIL,
  GET_DETECTION_QUALITY_SUMMARY_REQUEST,
  GET_DETECTION_QUALITY_SUMMARY_SUCCESS,
  GET_DETECTION_QUALITY_SUMMARY_FAIL,
  GET_DETECTION_QUALITY_INCIDENTS_REQUEST,
  GET_DETECTION_QUALITY_INCIDENTS_SUCCESS,
  GET_DETECTION_QUALITY_INCIDENTS_FAIL,
  GET_DETECTION_QUALITY_INCIDENT_DETAILS_REQUEST,
  GET_DETECTION_QUALITY_INCIDENT_DETAILS_SUCCESS,
  GET_DETECTION_QUALITY_INCIDENT_DETAILS_FAIL,
  GET_DEPARTMENTS_REQUEST,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAIL,
  GET_DEPARTMENT_DATA_SUMMARY_FAIL,
  GET_DEPARTMENT_DATA_SUMMARY_SUCCESS,
  GET_DEPARTMENT_DATA_SUMMARY_REQUEST,
  GET_RECENT_INCIDENTS_HEATMAP_REQUEST,
  GET_RECENT_INCIDENTS_HEATMAP_SUCCESS,
  GET_RECENT_INCIDENTS_HEATMAP_FAIL,
  GET_RECENT_INCIDENTS_HEATMAP_REQUEST_DETAILS,
  GET_RECENT_INCIDENTS_HEATMAP_SUCCESS_DETAILS,
  GET_RECENT_INCIDENTS_HEATMAP_FAIL_DETAILS,
  GET_HEATMAP_FILTER_LOOKUPS_SUCCESS,
  GET_HEATMAP_FILTER_LOOKUPS_FAILURE,
  GET_USER_LIST_SUCCESS,
  GET_USER_LIST_FAIL,
  GET_USER_LIST_REQUEST,
  SAVE_USER_REQUEST,
  SAVE_USER_SUCCESS,
  SAVE_USER_FAIL,
} from "../actions/general";

const initialState = {
  users: [],
  incidents: [],
  incidentsLoading: false,
  incidentDetail: [],
  incidentDetailLoading: false,
  summaryDataLoading: false,
  filters: null,
  summary: null,
  detectionQualitySummaryDataLoading: false,
  detectionQualityFilters: null,
  detectionQualitySummary: null,
  detectionQualityIncidents: [],
  detectionQualityIncidentsLoading: false,
  detectionQualityIncidentDetail: [],
  detectionQualityIncidentDetailLoading: false,
  scopeYears: [],
  loading: false,
  loadingRedirection: false,
  redirectionURL: null,
  navHide: localStorage.getItem("navHide") || false,
  lastRefreshDate: null,
  departments: null,
  departmentsLoading: false,
  departmentsError: null,
  departmentDataSummary: null,
  departmentDataSummaryLoading: false,
  departmentDataSummaryError: null,
  heatMapData: {
    municipality: null,
    street: null,
    loading: false,
  },
  smartSupervisionMapData: {
    municipality: null,
    street: null,
    loading: false,
  },
  smartSupervisionSummary: null,
  smartSupervisionSummaryLoading: false,
  highestElementsData: {
    district: null,
    street: null,
    loading: false,
  },
  vpiData: {
    district: null,
    street: null,
    loading: false,
  },
  coverageStreetMapData: [],
  vpiTrends: [],
  streetCoverage: [],
  coverageProgress: {
    loading: true,
    chart: null,
  },
  recentIncidentsHeatmap: [],
  recentIncidentsHeatmapLoading: false,
  recentIncidentsHeatmapError: null,
  recentIncidentsHeatmapDetails: [],
  recentIncidentsHeatmapDetailsLoading: false,
  recentIncidentsHeatmapDetailsError: null,
  subElementOptions: [],
  finalElementOptions: [],
  userList: [],
  userListLoading: false,
};

export default function general(state = initialState, action) {
  switch (action.type) {
    case BACKEND_REDIRECTION_REQUEST:
      return {
        ...state,
        loadingRedirection: true,
      };

    case BACKEND_REDIRECTION_SUCCESS:
      return {
        ...state,
        redirectionURL: action.payload,
        loadingRedirection: false,
      };

    case BACKEND_REDIRECTION_FAIL:
      return {
        ...state,
        loadingRedirection: false,
      };

    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };

    case GET_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: action.payload,
        userListLoading: false,
      };
    case GET_USER_LIST_FAIL:
      return {
        ...state,
        userList: action.payload,
        userListLoading: false,
      };

    case GET_USER_LIST_REQUEST:
      return {
        ...state,
        userListLoading: true,
      };

    case SAVE_USER_REQUEST:
      return {
        ...state,
        userListLoading: true,
      };

    case SAVE_USER_SUCCESS:
      return {
        ...state,
        userListLoading: false,
      };

    case SAVE_USER_FAIL:
      return {
        ...state,
        userListLoading: false,
      };
  
    case GET_INCIDENTS_REQUEST:
      return {
        ...state,
        incidentsLoading: true,
      };

    case GET_INCIDENTS_SUCCESS:
      return {
        ...state,
        incidents: action.payload,
        incidentsLoading: false,
      };

    case GET_INCIDENTS_FAIL:
      return {
        ...state,
        incidentsLoading: false,
      };

    case GET_INCIDENT_DETAILS_REQUEST:
      return {
        ...state,
        incidentDetailLoading: true,
      };

    case GET_INCIDENT_DETAILS_SUCCESS:
      return {
        ...state,
        incidentDetail: action.payload,
        incidentDetailLoading: false,
      };

    case GET_INCIDENT_DETAILS_FAIL:
      return {
        ...state,
        incidentDetailLoading: false,
      };

    case GET_FILTER_LOOKUP_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_FILTER_LOOKUP_SUCCESS:
      return {
        ...state,
        filters: action.payload,
        loading: false,
      };

    case GET_FILTER_LOOKUP_FAIL:
      return {
        ...state,
        loading: false,
      };

    case GET_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        summaryDataLoading: true,
      };

    case GET_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: action.payload,
        loading: false,
        summaryDataLoading: false,
      };

    case GET_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        summaryDataLoading: false,
      };

    case GET_DETECTION_QUALITY_INCIDENTS_REQUEST:
      return {
        ...state,
        detectionQualityIncidentsLoading: true,
      };

    case GET_DETECTION_QUALITY_INCIDENTS_SUCCESS:
      return {
        ...state,
        detectionQualityIncidents: action.payload,
        detectionQualityIncidentsLoading: false,
      };

    case GET_DETECTION_QUALITY_INCIDENTS_FAIL:
      return {
        ...state,
        detectionQualityIncidentsLoading: false,
      };

    case GET_DETECTION_QUALITY_INCIDENT_DETAILS_REQUEST:
      return {
        ...state,
        detectionQualityIncidentDetailLoading: true,
      };

    case GET_DETECTION_QUALITY_INCIDENT_DETAILS_SUCCESS:
      return {
        ...state,
        detectionQualityIncidentDetail: action.payload,
        detectionQualityIncidentDetailLoading: false,
      };

    case GET_DETECTION_QUALITY_INCIDENT_DETAILS_FAIL:
      return {
        ...state,
        detectionQualityIncidentDetailLoading: false,
      };

    case GET_DETECTION_QUALITY_FILTER_LOOKUP_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_DETECTION_QUALITY_FILTER_LOOKUP_SUCCESS:
      return {
        ...state,
        detectionQualityFilters: action.payload,
        loading: false,
      };

    case GET_DETECTION_QUALITY_FILTER_LOOKUP_FAIL:
      return {
        ...state,
        loading: false,
      };

    case GET_DETECTION_QUALITY_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        detectionQualitySummaryDataLoading: true,
      };

    case GET_DETECTION_QUALITY_SUMMARY_SUCCESS:
      return {
        ...state,
        detectionQualitySummary: action.payload,
        loading: false,
        detectionQualitySummaryDataLoading: false,
      };

    case GET_DETECTION_QUALITY_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        detectionQualitySummaryDataLoading: false,
      };

    case GET_SMART_SUPERVISION_SUMMARY_REQUEST:
      return {
        ...state,
        smartSupervisionSummaryLoading: true,
      };

    case GET_SMART_SUPERVISION_SUMMARY_SUCCESS:
      return {
        ...state,
        smartSupervisionSummary: action.payload,
        smartSupervisionSummaryLoading: false,
      };

    case GET_SMART_SUPERVISION_SUMMARY_FAIL:
      return {
        ...state,
        smartSupervisionSummaryLoading: false,
      };

    case GET_LAST_REFRESH_DATE_SUCCESS:
      return {
        ...state,
        lastRefreshDate: action.payload,
      };

    case TOGGLE_NAV_HIDE:
      return {
        ...state,
        navHide: !state.navHide,
      };

    case GET_MUNICIPALITY_AND_STREET_DATA_REQUEST:
      return {
        ...state,
        heatMapData: {
          ...state.heatMapData,
          loading: true,
        },
      };

    case GET_MUNICIPALITY_AND_STREET_DATA_SUCCESS:
      return {
        ...state,
        heatMapData: {
          ...action.payload,
          loading: false,
        },
      };

    case GET_MUNICIPALITY_AND_STREET_DATA_FAIL:
      return {
        ...state,
        heatMapData: {
          ...state.heatMapData,
          loading: false,
        },
      };

    case GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_REQUEST:
      return {
        ...state,
        smartSupervisionMapData: {
          ...state.smartSupervisionMapData,
          loading: true,
        },
      };

    case GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_SUCCESS:
      return {
        ...state,
        smartSupervisionMapData: {
          ...action.payload,
          loading: false,
        },
      };

    case GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_FAIL:
      return {
        ...state,
        smartSupervisionMapData: {
          ...state.smartSupervisionMapData,
          loading: false,
        },
      };

    case GET_HIGHEST_ELEMENTS_DATA_REQUEST:
      return {
        ...state,
        highestElementsData: {
          ...state.highestElementsData,
          loading: true,
        },
      };

    case GET_HIGHEST_ELEMENTS_DATA_SUCCESS:
      return {
        ...state,
        highestElementsData: {
          ...action.payload,
          loading: false,
        },
      };

    case GET_HIGHEST_ELEMENTS_DATA_FAIL:
      return {
        ...state,
        highestElementsData: {
          ...state.highestElementsData,
          loading: false,
        },
      };

    case GET_VPI_DATA_REQUEST:
      return {
        ...state,
        vpiData: {
          ...state.vpiData,
          loading: true,
        },
      };

    case GET_VPI_DATA_SUCCESS:
      return {
        ...state,
        vpiData: {
          ...action.payload,
          loading: false,
        },
      };

    case GET_VPI_TRENDS_FAIL:
      return {
        ...state,
        vpiData: {
          ...state.vpiData,
          loading: false,
        },
      };

    case GET_COVERAGE_STREET_DATA_SUCCESS:
      return {
        ...state,
        coverageStreetMapData: action.payload,
      };

    case GET_VPI_TRENDS_SUCCESS:
      return {
        ...state,
        vpiTrends: action.payload,
      };

    case GET_STREET_COVERAGE_SUCCESS:
      return {
        ...state,
        streetCoverage: action.payload,
      };

    case GET_ROAD_OPTIONS_SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          Road: action.payload,
        },
      };

    case GET_COVERAGE_PROGRESS_REQUEST:
      return {
        ...state,
        coverageProgress: {
          ...state.coverageProgress,
          loading: true,
        },
      };

    case GET_COVERAGE_PROGRESS_SUCCESS:
      return {
        ...state,
        coverageProgress: {
          loading: false,
          chart: action.payload,
        },
      };

    case GET_COVERAGE_PROGRESS_FAIL:
      return {
        ...state,
        coverageProgress: {
          ...state.coverageProgress,
          loading: false,
        },
      };

    case GET_DEPARTMENTS_REQUEST:
      return {
        ...state,
        departmentsLoading: true,
        departmentsError: null,
      };
    case GET_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departmentsLoading: false,
        departments: action.payload,
      };
    case GET_DEPARTMENTS_FAIL:
      return {
        ...state,
        departmentsLoading: false,
        departmentsError: action.payload.error,
      };

    case GET_DEPARTMENT_DATA_SUMMARY_REQUEST:
      return {
        ...state,
        departmentDataSummaryLoading: true,
        departmentDataSummaryError: null,
      };
    case GET_DEPARTMENT_DATA_SUMMARY_SUCCESS:
      return {
        ...state,
        departmentDataSummaryLoading: false,
        departmentDataSummary: action.payload,
      };
    case GET_DEPARTMENT_DATA_SUMMARY_FAIL:
      return {
        ...state,
        departmentDataSummaryLoading: false,
        departmentDataSummaryError: action.payload.error,
      };

    case GET_RECENT_INCIDENTS_HEATMAP_REQUEST:
      return {
        ...state,
        recentIncidentsHeatmapLoading: true,
        recentIncidentsHeatmapError: null,
      };
    case GET_RECENT_INCIDENTS_HEATMAP_SUCCESS:
      return {
        ...state,
        recentIncidentsHeatmap: action.payload,
        recentIncidentsHeatmapLoading: false,
      };
    case GET_RECENT_INCIDENTS_HEATMAP_FAIL:
      return {
        ...state,
        recentIncidentsHeatmapLoading: false,
        recentIncidentsHeatmapError: action.payload.error,
      };

    case GET_RECENT_INCIDENTS_HEATMAP_REQUEST_DETAILS:
      return {
        ...state,
        recentIncidentsHeatmapDetailsLoading: true,
        recentIncidentsHeatmapDetailsError: null,
      };
    case GET_RECENT_INCIDENTS_HEATMAP_SUCCESS_DETAILS:
      return {
        ...state,
        recentIncidentsHeatmapDetails: action.payload,
        recentIncidentsHeatmapDetailsLoading: false,
      };
    case GET_RECENT_INCIDENTS_HEATMAP_FAIL_DETAILS:
      return {
        ...state,
        recentIncidentsHeatmapDetailsLoading: false,
        recentIncidentsHeatmapDetailsError: action.payload.error,
      };

    case GET_HEATMAP_FILTER_LOOKUPS_SUCCESS:
      return {
        ...state,
        subElementOptions: action.payload.SubElement,
        finalElementOptions: action.payload.FinalElement,
      };

    case GET_HEATMAP_FILTER_LOOKUPS_FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
}
